import { ErrorMessage, Field } from "formik";
import { AddAccountStepProps } from "./StepModel";
import clsx from "clsx";
import { linkClientAccount } from "../AddAccountSlice";
import translations from "utils/translationUtility";

export const ClientAccountNumberStep: React.FC<AddAccountStepProps> = ({
  currentStep,
  formikProps,
}: AddAccountStepProps) => (
  <>
    <p className="col-lg-4 col-form-label required fw-bold fs-6">{translations.client} Account Number</p>

    <div className="col-lg-8">
      <div className="row">
        <div className="col-lg-6 fv-row">
          <Field
            aria-label="Client account number"
            type="text"
            className={clsx(
              "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
              { "is-invalid": formikProps.touched.clientAccountNumber && formikProps.errors.clientAccountNumber },
              {
                "is-valid": formikProps.touched.clientAccountNumber && !formikProps.errors.clientAccountNumber,
              }
            )}
            name="clientAccountNumber"
            placeholder={`${translations.client} Account Number`}
            autoComplete="off"
            data-test-id="add-account-form__client-account-number-input"
          />
          <div className="fv-plugins-message-container">
            <div className="fv-help-block">
              <ErrorMessage name="clientAccountNumber" key={currentStep.toString()} />
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
);

export const ClientAccountNumberSubmit = ({ values, thunkDispatch }) => {
  thunkDispatch(linkClientAccount({ clientAccountNumber: values.clientAccountNumber }));
};
